import { c as _c } from "react/compiler-runtime";
import { Checkbox } from "@/components/ui/checkbox";
import React from "react";
export function GDPRCookiesSettingsPanelToggle(props) {
  const $ = _c(6);
  let t0;
  if ($[0] !== props) {
    t0 = function handleClick() {
      props.onToggle(!props.isActive);
    };
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleClick = t0;
  let t1;
  if ($[2] !== handleClick || $[3] !== props.allowChange || $[4] !== props.isActive) {
    t1 = !props.allowChange ? <Checkbox disabled={true} checked={true} className="m-2" /> : <Checkbox checked={props.isActive} className="m-2" onCheckedChange={handleClick} />;
    $[2] = handleClick;
    $[3] = props.allowChange;
    $[4] = props.isActive;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
}